import { Database, install, use } from "@vuex-orm/core";
import DatePlugin from "./plugins/Date";
use(DatePlugin);
export class ORMDatabase {
    static install(options) {
        this._models.forEach((model) => this._ormDatabase.register(model));
        const plugin = install(this._ormDatabase, options);
        this._models = [];
        return plugin;
    }
    static registerEntity(model) {
        if (this._models.includes(model)) {
            return console.error(`[Vuex ORM Decorators] Unable to register Model '${model.name}'. Model '${model.name}' is already registered.`);
        }
        this._models.push(model);
    }
    static models() {
        if (this._ormDatabase && this._ormDatabase.isStarted) {
            const alreadyRegisteredModels = this._ormDatabase.entities.map((e) => e.model);
            return [...this._models, ...alreadyRegisteredModels];
        }
        return this._models;
    }
}
ORMDatabase._ormDatabase = new Database();
ORMDatabase._models = [];
//# sourceMappingURL=database.js.map